var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-popover",
    {
      directives: [
        {
          name: "tooltip",
          rawName: "v-tooltip",
          value: {
            content: _vm.content,
            trigger: _vm.isMob ? "manual" : "hover",
            show: _vm.show,
            placement: _vm.position,
          },
          expression:
            "{\n            content: content,\n            trigger: isMob ? 'manual' : 'hover',\n            show: show,\n            placement: position}",
        },
      ],
      attrs: { offset: "16", disabled: "" },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }